<template>
  <div>
    <!-- Snackbar de aviso antes de expirar -->
    <v-snackbar v-model="showAviso" :timeout="-1" bottom color="white" light elevation="8"
      multi-line style="z-index: 9999;">
      <div class="d-flex align-center">
        <v-icon color="orange darken-2" class="mr-2">mdi-clock-alert</v-icon>
        <div>
          <p class="body-2 font-weight-bold mb-0" style="color: #333;">Tu sesión expira pronto</p>
          <p class="caption mb-0" style="color: #666;">Se cerrará en {{ minutosRestantes }} min. ¿Deseas extenderla?</p>
        </div>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn color="teal" dark small v-bind="attrs" :loading="extending" @click="extenderSesion">
          Extender
        </v-btn>
        <v-btn text small v-bind="attrs" @click="cerrarSesionManual">
          Cerrar sesión
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar sesión expirada -->
    <v-snackbar v-model="showExpirado" :timeout="8000" color="error" text top>
      Tu sesión ha expirado por inactividad. Iniciá sesión nuevamente.
      <template v-slot:action="{ attrs }">
        <v-btn text small v-bind="attrs" @click="showExpirado = false">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { http } from '@/services/config';

export default {
  name: 'SessionTimer',
  data() {
    return {
      showAviso: false,
      showExpirado: false,
      extending: false,
      intervalId: null,
      minutosRestantes: 5
    };
  },
  computed: {
    estaLogueado() {
      return this.$store.getters.estaLogueado;
    }
  },
  watch: {
    estaLogueado(val) {
      if (val) {
        this.iniciarTimer();
      } else {
        this.detenerTimer();
      }
    }
  },
  mounted() {
    if (this.estaLogueado) {
      this.iniciarTimer();
    }
  },
  beforeDestroy() {
    this.detenerTimer();
  },
  methods: {
    iniciarTimer() {
      this.detenerTimer();
      this.showAviso = false;
      // Chequear cada 30 segundos
      this.intervalId = setInterval(() => {
        this.checkExpiration();
      }, 30000);
    },
    detenerTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    checkExpiration() {
      const expiresAt = localStorage.getItem('expiresAt');
      if (!expiresAt) return;

      const ahora = new Date();
      const expira = new Date(expiresAt);
      const faltanteMs = expira - ahora;
      const faltanteMin = faltanteMs / 60000;

      this.minutosRestantes = Math.max(0, Math.ceil(faltanteMin));

      // 5 minutos antes → mostrar aviso
      if (faltanteMin <= 5 && faltanteMin > 0 && !this.showAviso) {
        this.showAviso = true;
      }

      // Ya expiró → cerrar sesión automáticamente
      if (faltanteMin <= 0) {
        this.cerrarSesionExpirada();
      }
    },
    extenderSesion() {
      this.extending = true;
      http.post('api/refresh-token', {}, { skipAuthInterceptor: true })
        .then(res => {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('expiresAt', res.data.expires_at);
          this.showAviso = false;
          this.iniciarTimer();
        })
        .catch(() => {
          // Token ya expiró → no se puede refrescar
          this.cerrarSesionExpirada();
        })
        .finally(() => {
          this.extending = false;
        });
    },
    cerrarSesionManual() {
      this.showAviso = false;
      this.limpiarSesion();
    },
    cerrarSesionExpirada() {
      this.showAviso = false;
      this.detenerTimer();
      this.limpiarSesion();
      this.showExpirado = true;
    },
    limpiarSesion() {
      localStorage.removeItem('token');
      localStorage.removeItem('expiresAt');
      localStorage.removeItem('identificador');
      localStorage.removeItem('linkPhoto');
      this.$store.commit('vaciarCarrito');
      this.$store.commit('setLogueado', false);
      this.$store.commit('setIdentificador', '');
      this.$store.commit('setLinkPhoto', '');
    }
  }
};
</script>
